import React, { useEffect, useState, useContext } from 'react';
import { Nav } from '@fluentui/react';
import { Color } from '../../../const/Const';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import UserIcon from '../../../svg/BasicInfo/UserIcon';
import EducationIcon from '../../../svg/BasicInfo/EducationIcon';
import LanguageIcon from '../../../svg/BasicInfo/LanguageIcon';
import HrEmpInvalIcon from '../../../svg/BasicInfo/HrEmpInvalIcon';
import BankAccountIcon from '../../../svg/BasicInfo/BankAccountIcon';
import { UserContext } from '../../../context/UserContext';
import Basic from './Basic/Basic';
import Education from './Education/Education';
import Language from './Language/Language';
import HrEmpInval from './HrEmpInval/HrEmpInval';
import BankAccount from './BankAccount/BankAccount';

const BasicInformation = (props) => {

    const params = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { userInfo } = useContext(UserContext);

    const [vLinks, setVLinks] = useState([]);

    const onChangeSelectedTab = (p_value) => {
        if (params?.empid > 0) {
            navigate('/hrsuite/employee/' + params?.empid + "?tab=basic&page=" + p_value);
        }
    }

    useEffect(() => {
        let tVLinks = [];
        if (params?.empid > 0) {
            tVLinks = [
                {
                    name: 'Хувь хүний мэдээлэл',
                    url: '',
                    key: '',
                    target: '_blank',
                    onClick: () => {
                        onChangeSelectedTab('');
                    }
                },
                {
                    name: 'Боловсрол',
                    url: '',
                    icon: '',
                    key: 'education',
                    target: '_blank',
                    onClick: () => {
                        onChangeSelectedTab('education');
                    }
                },
                {
                    name: 'Хэлний мэдлэг',
                    url: '',
                    icon: '',
                    key: 'language',
                    target: '_blank',
                    onClick: () => {
                        onChangeSelectedTab('language');
                    }
                },
                {
                    name: 'Банкны данс',
                    url: '',
                    icon: '',
                    key: 'bankaccount',
                    target: '_blank',
                    onClick: () => {
                        onChangeSelectedTab('bankaccount');
                    }
                },
                {
                    name: 'Хөгжлийн бэрхшээл',
                    url: '',
                    icon: '',
                    key: 'hrempinvalid',
                    target: '_blank',
                    onClick: () => {
                        onChangeSelectedTab('hrempinvalid');
                    }
                }
            ];
        } else {
            tVLinks = [{
                name: 'Хувь хүний мэдээлэл',
                url: '',
                key: '',
                target: '_blank',
                onClick: () => {
                    onChangeSelectedTab('');
                }
            }];
        }

        setVLinks(tVLinks);

    }, [params?.empid]);

    let tSelectedTab = searchParams.get("page") ? searchParams.get("page") : "";
    let vPanel = <Basic />;

    if (tSelectedTab == "education") {
        vPanel = <Education />;
    } else if (tSelectedTab == "language") {
        vPanel = <Language />;
    } else if (tSelectedTab == "bankaccount") {
        vPanel = <BankAccount />;
    } else if (tSelectedTab == "hrempinvalid") {
        vPanel = <HrEmpInval />;
    }

    return (
        <div>
            <div style={{ display: 'flex' }}>
                <div style={{ boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.15)", backgroundColor: "#FBFBFB", paddingLeft: 8, paddingTop: 8, width: 200 }}>
                    <Nav
                        selectedKey={tSelectedTab}
                        styles={{
                            root: {
                                width: 200,
                                minHeight: 'calc(100vh - 200px)'
                            }
                        }}
                        groups={[{
                            links: vLinks
                        }]}
                        onRenderLink={(item) => {
                            if (item.key == '') {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <UserIcon active={item.key == tSelectedTab ? true : false} />
                                        <div style={{ marginLeft: 8, color: Color.grayText }}>{item.name}</div>
                                    </div>
                                );
                            } else if (item.key == 'education') {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <EducationIcon active={item.key == tSelectedTab ? true : false} />
                                        <div style={{ marginLeft: 8, color: Color.grayText }}>{item.name}</div>
                                    </div>
                                );
                            } else if (item.key == 'language') {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <LanguageIcon active={item.key == tSelectedTab ? true : false} />
                                        <div style={{ marginLeft: 8, color: Color.grayText }}>{item.name}</div>
                                    </div>
                                );
                            } else if (item.key == 'bankaccount') {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <BankAccountIcon active={item.key == tSelectedTab ? true : false} />
                                        <div style={{ marginLeft: 8, color: Color.grayText }}>{item.name}</div>
                                    </div>
                                );
                            } else if (item.key == 'hrempinvalid') {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <HrEmpInvalIcon active={item.key == tSelectedTab ? true : false} />
                                        <div style={{ marginLeft: 8, color: Color.grayText }}>{item.name}</div>
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        }}
                    >
                    </Nav>
                </div>
                <div style={{ backgroundColor: Color.grayBackground, flex: 1 }}>
                    {vPanel}
                </div>
            </div>
        </div>
    );
}

export default BasicInformation;